import {useProductRoutes} from './routes';
import { useGetProductCommonInfoQuery, useReplaceProductMutation } from '../../features/api/productApi';
import { GetDefaultIndexWithReplace } from '../../components/crud/getDefaultIndexWithReplace';
import { ProductReplacer } from './productReplacer';


export {useProductRoutes};


export default GetDefaultIndexWithReplace({
  title: "محصولات",
  query: useGetProductCommonInfoQuery,
  replaceMutation: useReplaceProductMutation,
  replacer: (replaceCallback) => <ProductReplacer replaceCallback={replaceCallback} />
});
